import React from 'react'
import useToastStore from '../../../../stores/useToastStore/useToastStore'
import { Toast } from '../Toast/Toast'
import { useAutoAnimate } from '@formkit/auto-animate/react'

type ToastContainerProps = React.PropsWithChildren

export const ToastContainer: React.FC<ToastContainerProps> = () => {
    const [parent] = useAutoAnimate({
        duration: 250,
        easing: 'ease-out',
    })

    const alerts = useToastStore((state) => state.alerts)

    return (
        <div ref={parent} className="absolute left-0 right-0 space-y-4">
            {alerts
                .slice()
                .reverse()
                .map((alert) => (
                    <Toast
                        key={alert.id}
                        id={alert.id}
                        variant={alert.variant}
                        title={alert.title}
                        description={alert.description}
                    />
                ))}
        </div>
    )
}
